@for (transportAssignment of transportAssignments; track transportAssignment) {
  <app-action-item borderColor="#dedede" titleColor="#000000" [iconCSS]="actionItem?.iconCSS"
    backgroundColor="var(--shade-2-color)" color="#000000"
    titleDictionaryKey="dd.appc_cfg_action_item.{{actionItem.id}}.name"
    (click)="handleClick(transportAssignment)"
    matRipple class="action-item">
    <yard-action-tablet-planned-assignment-details [transportAssignmentSight]="transportAssignment"></yard-action-tablet-planned-assignment-details>
  </app-action-item>
}
